import { useEffect, useRef, useState } from 'react';
import QRCode from 'qrcode-generator';

interface QRCodeViwerProps {
  width?: number;
  height?: number;
  matrix?: number[];
  top?: number;
  left?: number;
  right?: number;
  size?: number;
  text?: string;
  bgColor?: string;
  fgColor?: string;
  level?: string;
}
function QRCodeViewer({
  matrix = [0, 0, 0, 0, 0, 0],
  top = 0,
  left = 0,
  right,
  size = 0,
  text = '',
}: QRCodeViwerProps) {
  const [refresh, setRefresh] = useState(false);
  const isRight = right !== undefined ? true : false;
  const canvasRef = useRef<any>();

  const margin = 0.15 * size;
  const timeoutRef = useRef<any>(null);

  useEffect(() => {
    const debouncedRender = () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        const qrcode = QRCode(0, 'L');
        qrcode.addData(text);
        qrcode.make();
        const cellSize = (size - margin) / qrcode.getModuleCount();
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        qrcode.renderTo2dContext(ctx, cellSize);
      }, 300);
    };
    debouncedRender();
    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [left, top, right, size, text, refresh]);

  useEffect(() => {
    const timer = setInterval(() => {
      clearInterval(timer);
      setRefresh(!refresh);
    }, 1000);
  }, []);

  return (
    <div
      style={{
        position: 'relative',
        transition: 'transform 500ms',
        transformOrigin: `${isRight ? 'right' : 'left'} top`,
        transform: `matrix(${matrix.join(', ')})`,
      }}
    >
      <div
        style={{
          position: 'absolute',
          transition: 'height 500ms, top 500ms, left 500ms, right 500ms',
          top,
          ...(() => (isRight ? { right } : { left }))(),
        }}
      >
        <div
          style={{
            position: 'relative',
            transition: 'width 500ms, height 500ms',
            height: size,
            width: size,
            backgroundColor: 'white',
            borderRadius: margin / 4,
          }}
        >
          <canvas
            ref={canvasRef}
            style={{
              position: 'absolute',
              top: margin / 2,
              left: margin / 2,
              transition: 'width 500ms, height 500ms',
            }}
          ></canvas>
        </div>
      </div>
    </div>
  );
}

export default QRCodeViewer;
